import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SummarySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SummarySVG;
